// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2320db5c","513":"f5ed891a","703":"fcc573ac","787":"0979e147"}[chunkId] + ".chunk.js";
};